<template>
  <div id="app" v-loading="loading.show" :element-loading-text="loading.text || '加载中'" :class="{ dark: isDark }"
    element-loading-spinner="el-icon-loading">
    <router-view v-if="!isLogin && isShow" />
    <el-container v-else class="uapp" :class="[pagename]">
      <page-header />
      <el-main>
        <div class="layer-main" :class="{ 'show-sidebar': show }">
          <page-sidebar v-if="show" />
          <div class="layer-content">
            <a v-if="isShowBack" class="back" @click="onBack"><i class="el-icon-arrow-left"></i><span>返回</span></a>
            <KeepAlive :exclude="KeepAliveExcludeList">
              <router-view v-if="isShow" />
            </KeepAlive>
          </div>
        </div>
      </el-main>
      <page-footer/>
    </el-container>
    <checkVersion :exclude="exclude" storageKey="_version_zysj_" />
  </div>
</template>

<script>
import PageHeader from '@/components/pageHeader.vue';
import PageFooter from '@/components/pageFooter.vue';
import PageSidebar from '@/components/pageSidebar.vue';
import checkVersion from '@/components/checkVersion.vue'
import { mapGetters } from "vuex";

import Cookies from 'js-cookie'

export default {
  computed: {
    ...mapGetters(["isShow", "isLogin", "loading", "isDark", "version"]),
    isShowBack() {
      return ['drugDetail', 'pageCatalogue', 'bookDetail'].includes(this.$route.name);
    },
    pagename() {
      return "pagename-" + this.$route.name;
    },
    show() {
      return ['bookDetail', 'drugDetail'].includes(this.$route.name)
    },
  },
  components: {
    checkVersion, PageHeader, PageSidebar,PageFooter
  },
  data() {
    return {
      exclude: ['userInfo'],
      KeepAliveExcludeList: ['personalData', 'articleDetail']
    }
  },
  methods: {
    onBack() {
      this.$router.back();
    },
  },
  created() {
    this.$store.commit("openApp", this);
    // setTimeout(() => {
    //   this.$refs.appScrollbar.$el.scrollTop = 1000;
    // }, 5000)
    
    // 测试
    // console.log(
    //   "--------->",
    //   Cookies.get('userInfi123456')
    // );
  }
};
</script>

<style></style>